/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-computed-key */
import { useEffect, useState } from "react";
import { currencyFormat, idNamingConversion } from "../../../../../helpers/utilities";
import { PrimaryDrawer } from "../../Drawer/PrimaryDrawer";
import ReportModal from "../../ReportModal";
import { getRequest } from '../../../../../helpers/axiosClient';
import { AutoCompleteComponent } from "../../AutoCompleteComponent";
import { useDispatch, useSelector } from "react-redux";
import customStyles from "../../../../../assets/styles/customStyles";
import { Button, Box, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import productActions from "../../../../Product/Product/redux/actions";
import clsx from "clsx";
import productSetupActions from "../../../../Product/Setup/redux/actions";
import { SelectedIcon, UnSelectedIcon } from "../../Icons/selectedIcon";
import DateIcon from "../../Icons/Date";
import { Space, Col, Row } from 'antd';
import moment from 'moment';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { emptyValidation } from "../../../../../helpers/validation";


export const TransferValueReport = (props) => {
    const { visible, onTransferValueVisible, title, onMenuTitle } = props;
    const { businessDetails } = useSelector(state => state.homeReducer);
    const { myProductdetails } = useSelector(state => state.productProductReducer);
    const { locationDetails } = useSelector(state => state.productSetupReducer);

    const [filterValues, setFilterValues] = useState({
        fromDate: new Date(),
        toDate: new Date(),
        reportType: 'all'
    });

    const dispatch = useDispatch();
    const [reportOpen, setReportOpen] = useState(false);
    const [transferValueData, setTransferValueData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({});

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const transferValueFilter = (e) => {
        e.preventDefault();
        let emptyFromLocation = emptyValidation('From Location', filterValues?.fromLocation?.id, 'dropDown');
        let emptyToLocation = emptyValidation('To Location', filterValues?.toLocation?.id, 'dropDown');

        if (filterValues?.reportType === 'shipped' && !emptyFromLocation.isValid) {
            setError({ fromLocation: emptyFromLocation?.errors });
            return;
        } else if (filterValues?.reportType === 'received' && !emptyToLocation.isValid) {
            setError({ toLocation: emptyToLocation?.errors });
            return;
        } else {
            setError({});
        }

        try {
            setLoading(true);
            let url = `${process.env.REACT_APP_API_URL}/stockTransferReport?reportType=${filterValues?.reportType}`;

            if (filterValues?.product?.id) {
                url += `&productId=${filterValues?.product?.id}`;
            }

            if (filterValues?.fromLocation?.id) {
                url += `&fromLocationId=${filterValues?.fromLocation?.id}`;
            }

            if (filterValues?.toLocation?.id) {
                url += `&toLocationId=${filterValues?.toLocation?.id}`;
            }

            if (filterValues?.fromDate) {
                url += `&fromDate=${moment(filterValues?.fromDate).format("YYYY-MM-DD")}`;
            }

            if (filterValues?.toDate) {
                url += `&toDate=${moment(filterValues?.toDate).format("YYYY-MM-DD")}`;
            }

            let response = getRequest(url);
            response.then(payload => {
                setTransferValueData(payload.data);
                setReportOpen(true);
                setLoading(false);
            }).catch(error => {
                // Handle any errors
                setLoading(false);
            })
        } catch (error) {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (visible) {
            productApi();
            locationApi();
        }
    }, [visible])

    const handleClose = () => {
        setFilterValues({
            fromDate: new Date(),
            toDate: new Date(),
            reportType: 'all'
        });
        onTransferValueVisible(false);
        onMenuTitle('');
    }

    const locationApi = (search = '', id = '') => {
        let filter = { ["or"]: [] };

        if (search) {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
        }

        if (id) {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: productSetupActions.LOCATION_DETAILS_START, url: 'locations',
            filter: {
                where: !filter.or || filter.or.length === 0 ? {} : filter,
                order: 'id desc',
                limit: 50,
                skip: 0
            },
        });
    }

    const transferValueTitle = (values) => {
        let v = '';
        if (values?.product?.productName) {
            v = `Product : ${values?.product?.productName} `;
        }
        if (values?.date) {
            v += `${values?.product?.productName ? ' - ' : ''}Date : ${moment(values?.date).format("DD-MM-YYYY")} `;
        }
        return v;
    }

    const productApi = (search = '', id = '') => {
        let filter = { ["and"]: [{ status: 'ACTIVE' }] };
        let or = { ["or"]: [] };
        if (search !== undefined && search !== null && search !== '') {
            or['or'].push({ productName: { like: '%' + search.trim() + '%' } });
            or['or'].push({ description: { like: '%' + search.trim() + '%' } });
            or['or'].push({ productId: { like: '%' + search.trim() + '%' } });
            or['or'].push({ barcode: { like: '%' + search.trim() + '%' } });
            or['or'].push({ code: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            or['or'].push({ id: id });
        }

        if (or.or.length > 0) {
            filter['and'].push(or);
        }
        dispatch({
            type: productActions.MYPRODUCT_DETAILS_START, url: 'client-products',
            filter: {
                where: filter,
                order: 'id desc',
                limit: 50,
                skip: 0
            },
        });
    }

    const changeHandler = (e, name = '', relation = false) => {
        setFilterValues({
            ...filterValues,
            [name]: e
        });
    }

    const classes = customStyles();
    return (
        <>
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={title}
                width={"360px"}
                className={clsx(classes.closeBackGround, classes.width100P)}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => transferValueFilter(e)}>
                        <div className={classes.customFormFlex}>
                            <AutoCompleteComponent
                                name={`Product `}
                                heads={[{ key: "productName", name: "Product Name" },
                                { key: "code", name: "Product Code" },
                                { key: "productId", name: "Product ID" }]}
                                details={myProductdetails}
                                id={idNamingConversion("Product", "stockValue", "DropDown")}
                                parentValue={customObject(myProductdetails, filterValues?.product?.id)}
                                onChange={(data) => changeHandler(data, 'product', true)}
                                position="bottom"
                                searchType={(s) => productApi(s)}
                            />
                            <FormControl
                                tabIndex={-1}
                                className={clsx(classes.dropDownPointer, classes.customRadioButton, classes.margin30t, classes.customIdentityRadioButton)}
                                variant={'standard'}
                                fullWidth
                                style={{ paddingLeft: 5 }}>
                                <FormLabel className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Report Type</FormLabel>
                                <RadioGroup
                                    row
                                    defaultValue={"reportType"}
                                    value={filterValues?.reportType}
                                    onChange={(e) => changeHandler(e.target.value, 'reportType')}>
                                    <FormControlLabel value="all" control={<Radio
                                        checkedIcon={<UnSelectedIcon />}
                                        icon={<SelectedIcon />}
                                    />} label="All" />
                                    <FormControlLabel value="shipped" control={<Radio
                                        checkedIcon={<UnSelectedIcon />}
                                        icon={<SelectedIcon />}
                                    />} label="Shipped" />
                                    <FormControlLabel value="received" control={<Radio
                                        checkedIcon={<UnSelectedIcon />}
                                        icon={<SelectedIcon />}
                                    />} label="Received" />
                                </RadioGroup>
                            </FormControl>
                            <AutoCompleteComponent
                                name={`From Location`}
                                heads={[{ 'key': 'name', 'name': 'Location Name' }]}
                                details={locationDetails}
                                id={idNamingConversion("Product", "stockValue", "DropDown")}
                                parentValue={customObject(locationDetails, filterValues?.fromLocation?.id)}
                                onChange={(data) => changeHandler(data, 'fromLocation', true)}
                                position="bottom"
                                parentError={error?.fromLocation || false}
                                customClasses={classes.margin30t}
                            />
                            <AutoCompleteComponent
                                name={`To Location `}
                                heads={[{ 'key': 'name', 'name': 'Location Name' }]}
                                details={locationDetails}
                                id={idNamingConversion("Product", "stockValue", "DropDown")}
                                parentValue={customObject(locationDetails, filterValues?.toLocation?.id)}
                                onChange={(data) => changeHandler(data, 'toLocation', true)}
                                position="bottom"
                                parentError={error?.toLocation || false}
                                customClasses={classes.margin30t}
                            />
                            <div className={clsx(classes.margin30t, classes.dateAdjust)}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDatePicker
                                        fullWidth
                                        slots={{
                                            openPickerIcon: DateIcon
                                        }}
                                        views={['year', 'month', 'day']}
                                        value={filterValues?.fromDate}
                                        format='dd/MM/yyyy'
                                        label="From Date"
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        slotProps={{
                                            textField: {
                                                id: idNamingConversion('Date', 'productAnalysis', 'TextField'),
                                                autoComplete: 'one-time-code'
                                            },
                                        }}
                                        // readOnly={true}
                                        onChange={(newValue) => {
                                            (newValue === null || newValue === 'Invalid Date') ? changeHandler(new Date(), 'fromDate') : changeHandler(newValue, 'fromDate')
                                        }}
                                    />
                                </LocalizationProvider>
                            </div>
                            <div className={clsx(classes.margin30t, classes.dateAdjust)}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDatePicker
                                        fullWidth
                                        slots={{
                                            openPickerIcon: DateIcon
                                        }}
                                        views={['year', 'month', 'day']}
                                        value={filterValues?.toDate}
                                        format='dd/MM/yyyy'
                                        label="To Date"
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        slotProps={{
                                            textField: {
                                                id: idNamingConversion('Date', 'productAnalysis', 'TextField'),
                                                autoComplete: 'one-time-code'
                                            },
                                        }}
                                        // readOnly={true}
                                        onChange={(newValue) => {
                                            (newValue === null || newValue === 'Invalid Date') ? changeHandler(new Date(), 'toDate') : changeHandler(newValue, 'toDate')
                                        }}
                                    />
                                </LocalizationProvider>
                            </div>
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            <Space direction="horizontal" align="center">
                                <Button
                                    key="save"
                                    type="submit"
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.modalBtn, { [classes.loading]: loading })}>OK</Button>
                                <Button
                                    key="cancel"
                                    color='primary'
                                    variant="contained"
                                    onClick={() => handleClose()}
                                    className={clsx(classes.AddMoreBtn, { [classes.loading]: loading })}>Cancel</Button>
                            </Space>
                        </div>
                    </Box>
                }
            />
            <ReportModal
                title={title}
                open={reportOpen}
                list={
                    <>
                        <div className={clsx(classes.downloadsReportHeading, classes.textAlignCenter)}>
                            <h4 className={classes.aTitle}>{title}</h4>
                            <p className={classes.downloadsHeading}>{transferValueTitle(filterValues)}</p>
                        </div>
                        <Row className={clsx(classes.bill, classes.billReportHead, classes.margin20t, classes.viewPrint, 'no-break')}>
                            <Col span={2}><h6 style={{ fontSize: 14 }}>Product ID</h6></Col>
                            <Col span={5}><h6 style={{ fontSize: 14 }}>Product Description</h6></Col>
                            <Col span={2}><h6 style={{ fontSize: 14 }}>Unit</h6></Col>
                            <Col span={2}><h6 style={{ fontSize: 14 }}>Shipped Qty.</h6></Col>
                            <Col span={2}><h6 style={{ fontSize: 14 }}>Received Qty.</h6></Col>
                            <Col span={3}><h6 style={{ fontSize: 14 }}>Cost Amount</h6></Col>
                            <Col span={3}><h6 style={{ fontSize: 14 }}>Price</h6></Col>
                            <Col span={3}><h6 style={{ fontSize: 14 }}>Value</h6></Col>
                            <Col span={2}><h6 style={{ fontSize: 14 }}>MRP</h6></Col>
                        </Row>
                        {
                            transferValueData?.length > 0 ? transferValueData.map((data, i) => (
                                <Row className={clsx(classes.bill, 'no-break')}>
                                    <Col span={2}><p style={{ fontSize: 14 }}>{data?.productId || ''}</p></Col>
                                    <Col span={5}><p style={{ fontSize: 14, padding: "0 5px" }}>{data?.description || '---'}</p></Col>
                                    <Col span={2}><p style={{ fontSize: 14 }}>{data?.unitName || '---'}</p></Col>
                                    <Col span={2}><p style={{ fontSize: 14 }}>{data?.totalToQuantity || '---'}</p></Col>
                                    <Col span={2}><p style={{ fontSize: 14 }}>{data?.totalReceivedQuantity || '---'}</p></Col>
                                    <Col span={3}><p style={{ fontSize: 14 }}>{`₹ ${currencyFormat(data?.costAmount || 0)}`}</p></Col>
                                    <Col span={3}><p style={{ fontSize: 14 }}>{`₹ ${currencyFormat((data?.price || 0))}`}</p></Col>
                                    <Col span={3}><p style={{ fontSize: 14 }}>{`₹ ${currencyFormat(((data?.totalToQuantity || 0) * (data?.price || 0)))}`}</p></Col>
                                    <Col span={2}><p style={{ fontSize: 14 }}>{`₹ ${currencyFormat(data?.mrp || 0)}`}</p></Col>
                                </Row>)) : <Row className={classes.noBorder}><Col span={24} style={{ textAlign: "center", marginTop: 15 }}>Sorry, we couldn’t find any data for the selected criteria. Please refine your filter</Col></Row>
                        }
                        <Row className={clsx(classes.bill)}>
                            <Col span={7}></Col>
                            <Col span={2}><h6 style={{ backgroundColor: "#fff", color: "#000", fontWeight: "500", fontSize: 18 }}>Total:</h6></Col>
                            <Col span={2}><h6 style={{ backgroundColor: "#fff", color: "#000", fontWeight: "500", fontSize: 18 }}>{(transferValueData?.length > 0 ? transferValueData.reduce((a, v) => a = parseFloat(a) + parseFloat(v?.totalToQuantity || 0), 0) : 0)}</h6></Col>
                            <Col span={2}><h6 style={{ backgroundColor: "#fff", color: "#000", fontWeight: "500", fontSize: 18 }}>{(transferValueData?.length > 0 ? transferValueData.reduce((a, v) => a = parseFloat(a) + parseFloat(v?.totalReceivedQuantity || 0), 0) : 0)}</h6></Col>
                            <Col span={3}><h6 style={{ backgroundColor: "#fff", color: "#000", fontWeight: "500", fontSize: 18 }}>₹ {currencyFormat(transferValueData?.length > 0 ? transferValueData.reduce((a, v) => a = parseFloat(a) + parseFloat(v?.costAmount || 0), 0) : 0)}</h6></Col>
                            <Col span={3}><h6 style={{ backgroundColor: "#fff", color: "#000", fontWeight: "500", fontSize: 18 }}></h6></Col>
                            <Col span={3}><h6 style={{ backgroundColor: "#fff", color: "#000", fontWeight: "500", fontSize: 18 }}>₹ {currencyFormat(transferValueData?.length > 0 ? transferValueData.reduce((a, v) => a = parseFloat(a) + parseFloat(((v?.totalToQuantity || 0) * (v?.price || 0))), 0) : 0)}</h6></Col>
                            <Col span={2}><h6 style={{ backgroundColor: "#fff", color: "#000", fontWeight: "500", fontSize: 18 }}></h6></Col>
                        </Row>
                    </>
                }
                businessDetails={businessDetails}
                reportType={'landscape'}
                handleClose={() => { setReportOpen(false); onMenuTitle(''); }}
            />
        </>
    )
}
